export function getContactsText(
    contacts: {
        firstName: string;
        lastName?: string | null;
    }[],
) {
    return contacts.length
        ? contacts
              .map((contact) =>
                  `${contact.firstName} ${contact.lastName ?? ''}`.trim(),
              )
              .join(', ')
        : '';
}
